/**
 * Formats a UTC date string for display in the cart timing row.
 * Returns "{todayLabel} HH:MM" when the date falls on the current calendar day,
 * or just "HH:MM" for any other date.
 * Falls back to the raw string when parsing fails.
 *
 * @param locale   BCP 47 locale tag (e.g. intl.locale from useIntl) — used for
 *                 toLocaleTimeString so the time format matches the app's active locale.
 * @param todayLabel  Translated "Today" string from the caller — avoids hardcoding English.
 */
export function formatScheduledTime(
	utcString: string,
	locale?: string,
	todayLabel = 'Today',
): string {
	const date = new Date(utcString)
	if (isNaN(date.getTime())) return utcString
	const now = new Date()
	const isToday =
		date.getFullYear() === now.getFullYear() &&
		date.getMonth() === now.getMonth() &&
		date.getDate() === now.getDate()
	const timeStr = date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
	return isToday ? `${todayLabel} ${timeStr}` : timeStr
}
